import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const NebulaDriftAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for (let i = 0; i < 8; i++) {
    ctx.globalAlpha = (1 - progress) * 0.25;
    drawBlastShape(ctx, e, e.maxRadius * (1 + progress * i * 0.5));
    ctx.fill();
  }
};

registerBlastAnimation('NEBULA_DRIFT', NebulaDriftAnimation);
